import { createContext } from "react";

export const SignatureContext = createContext();